import { useEffect, useRef, useSyncExternalStore } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../../../infrastructure/Firebase/config";
import { store } from "../../../infrastructure/store/store";
import { deleteToken } from "../../../infrastructure/store/authSlice";
import { clearSessionData } from "../../../infrastructure/utils/clearSessionData";
import { peekPostAuthRedirect, setPostAuthRedirect } from "../../../infrastructure/storage/postAuthRedirect";
import {
  isSessionExpiring,
  subscribeSessionExpiration,
  SESSION_EXPIRED_KEY,
  getSessionExpiredMessage,
} from "../../../infrastructure/utils/sessionExpiration";
import { readStoredInterfaceLanguage } from "../../../shared/utils/interfaceLanguage";
import { loginPath } from "../../routes/routes";

// Unmount all session-owned providers/screens immediately. A full navigation
// also discards in-memory caches, subscriptions and requests from the old session.
//
// El caso de alta incompleta (401 "Usuario inactivo o eliminado.") NO pasa por aqui:
// no cierra la sesion, solo cambia el hash a /user_setup (ver
// sessionExpiration.js#redirectToUserSetup) sin desmontar nada ni recargar la pagina.
export default function SessionExpirationBoundary({ children }) {
  const expired = useSyncExternalStore(subscribeSessionExpiration, isSessionExpiring);
  const started = useRef(false);
  useEffect(() => {
    if (!expired || started.current) return;
    started.current = true;
    const destination = peekPostAuthRedirect();
    store.dispatch(deleteToken());
    Promise.resolve().then(() => signOut(auth)).catch((error) => {
      console.error("No se pudo cerrar la sesión de Firebase:", error);
    }).finally(() => {
      // Remove any data written by requests already in flight during sign-out.
      clearSessionData();
      if (destination) setPostAuthRedirect(destination);
      sessionStorage.setItem(SESSION_EXPIRED_KEY, "true");
      window.location.replace(loginPath);
    });
  }, [expired]);

  // Este componente monta en index.js, por encima de LangContext, asi que el
  // idioma se lee del almacenamiento (clearSessionData lo conserva).
  if (expired)
    return (
      <div role="alert">
        {getSessionExpiredMessage(readStoredInterfaceLanguage())}
      </div>
    );
  return children;
}
